<template>
  <div class="trainer-actions tract">
    <!-- <div class="tract_grid" :class="gridClass || ''"> -->
    <div
      class="tract_grid"
      :data-tst="l_actions.length ? `${tstPrefix}_actions` : ''"
      :class="[`tract_grid_${l_actions.length}`, gridClass || '']"
    >
      <ActionBtn
        v-for="(a, idx) in l_actions"
        :key="`${a.code}_${idx}`"
        :action="a"
        :hasResult
        :hasFreq
        :hasEv
        :hasHighlight="hasResult && a[selectKey]"
        :hasCheatFrequency
        :showBetsIn
        :bettingInfo
        :loading
        :data-tst="`${tstPrefix}_action_${a.code}${hasResult && a[selectKey] ? '_highlight' : ''}`"
        class="tract_grid_item"
        style="--clr-default: var(--clr-opponent)"
        @click="handleActionClick"
      />
    </div>
  </div>
</template>

<script>
import ActionBtn from '@/components/ActionBtn/ActionBtn'
import { getRaisesNonRaises, getGroupedActions } from '@/helpers/grouping'

export default {
  name: 'TrainerActions',
  components: {
    ActionBtn,
  },
  props: {
    bettingInfo: Object,
    actions: Array,
    grouping: String,
    hasBetHotkeys: Boolean,
    hasResult: Boolean,
    hasEv: Boolean,
    hasFreq: Boolean,
    hasChart: Boolean,
    selectKey: { default: 'is_selected' },
    gridClass: String,
    hasCheatFrequency: Boolean,
    loading: Boolean,
    loadingBtns: { default: () => 5 },
    active: Boolean,
    manyActions: Boolean,
    currentPot: Number,
    tstPrefix: { default: 'trainer_table_0' },
  },
  emits: ['click:action'],
  methods: {
    handleActionClick(a) {
      if (this.grouping === 'swv_grouping_none') {
        this.$emit('click:action', a)
        return
      }
      if (['X', 'C', 'F'].some(c => a.code === c)) {
        this.$emit('click:action', a)
        return
      }

      const topFreqAction = a.topFrequencyAction
      this.$emit('click:action', topFreqAction)
    },
  },
  computed: {
    l_actions() {
      // console.log(this.actions)
      if (this.loading) {
        return [...new Array(this.loadingBtns).keys()]
      }
      let res = this.actions

      if (this.grouping !== 'swv_grouping_none') {
        res = getGroupedActions({
          actions: res,
          grouping: this.grouping,
          groupValues: ['frequency'],
          raisesFirst: false,
        })
        res = res.map(a => {
          if (['X', 'C', 'F'].some(c => a.code === c)) {
            return a
          }
          const frequencies = a.actions.map(aa => aa.frequency)
          const topFreq = Math.max(...frequencies)
          const topFreqIdx = frequencies.indexOf(topFreq)

          const topFrequencyAction = a.actions[topFreqIdx] || a.actions[0] // fallback for when you dont get actions from hero (429) and you play custom spot so there are actions but no frequencies

          const groupSelectedAction = a.actions.find(aa => aa.is_selected || aa.is_preselected)
          const aaa = groupSelectedAction || topFrequencyAction

          const r = {
            ...a,
            correctness: aaa.correctness,
            correctness_group: aaa.correctness_group,
            is_selected: aaa.is_selected,
            is_preselected: aaa.is_preselected,
            topFrequencyAction,
          }
          return r
        })
        if (this.manyActions && this.hasResult && this.grouping === 'swv_grouping_4') {
          res = res.filter(aa => (aa.type !== 'RAISE' ? true : aa.is_preselected || aa.is_selected))
        }
      }
      // console.log(res)
      return res || []
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    hotkeysPressedBottom(keys) {
      if (!this.active) return
      if (!keys) return
      const hotkeyActions = {
        action_check_fold: {
          keys: this.hotkeys.action_check_fold.keyCombination,
          fn: () => {
            const a = this.l_actions.find(i => i.code === 'X' || i.code === 'F')
            if (a) {
              this.$emit('click:action', a)
            }
          },
        },
        action_call: {
          keys: this.hotkeys.action_call.keyCombination,
          fn: () => {
            const a = this.l_actions.find(i => i.code === 'C')
            if (a) {
              this.$emit('click:action', a)
            }
          },
        },
        action_allin: {
          keys: this.hotkeys.action_allin.keyCombination,
          fn: () => {
            const a = this.l_actions.find(i => i.allin)
            if (a) {
              this.$emit('click:action', a)
            }
          },
        },
        ...(this.hasBetHotkeys
          ? {
              action_raise: {
                keys: ['1'],
                matchFn: _keys => _keys.length === 1,
                fn: () => {
                  const num = Number(keys[0])
                  const { raises } = getRaisesNonRaises({ actions: this.l_actions })
                  if (raises[num - 1]) {
                    const a = raises[num - 1]
                    if (a) {
                      this.handleActionClick(a)
                    }
                  }
                },
              },
            }
          : {}),
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>
<style lang="scss">
.tract {
  display: flex;
  flex-direction: column;
  position: relative;
  // flex: 1;
}

.tract {
  &_grid {
    display: grid;
    grid-gap: 0.25rem;
    width: 100%;
    flex-shrink: 0;
    // maybe redo by this - much simpler
    // https://css-irl.info/controlling-leftover-grid-items/
    // grid-template-columns: repeat(6, 1fr);

    &_mobile {
      grid-template-columns: 1fr !important;
      grid-template-areas: unset !important;
      .tract_grid_item {
        grid-area: unset !important;
        // grid-column: unset !important;
      }
    }
    // &_item {
    //   grid-column: span 2;
    //   // 2 orphans
    //   &:last-child:nth-child(3n - 1) {
    //     grid-column-end: -2;
    //   }
    //   &:nth-last-child(2):nth-child(3n + 1) {
    //     grid-column-end: 4;
    //   }
    //   // 1 orphan
    //   &:last-child:nth-child(3n - 2) {
    //     grid-column-end: 5;
    //   }
    // }
    &_1 {
      grid-template-columns: repeat(3, 1fr);
      grid-template-areas: '. a .';
      .tract_grid_item {
        grid-area: a;
      }
    }
    &_2 {
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas: '. a a b b .';
      .tract_grid_item {
        &:nth-child(1) {
          grid-area: a;
        }
        &:nth-child(2) {
          grid-area: b;
        }
      }
    }
    &_2-5 {
      grid-template-columns: repeat(8, 1fr);
      grid-template-areas: '. a a a b b b .';
      .tract_grid_item {
        &:nth-child(1) {
          grid-area: a;
        }
        &:nth-child(2) {
          grid-area: b;
        }
      }
    }
    &_3 {
      grid-template-columns: repeat(3, 1fr);
    }
    &_4 {
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        'a a b b c c'
        '. . d d . .';
      .tract_grid_item {
        &:nth-child(1) {
          grid-area: a;
        }
        &:nth-child(2) {
          grid-area: b;
        }
        &:nth-child(3) {
          grid-area: c;
        }
        &:nth-child(4) {
          grid-area: d;
        }
      }
    }
    &_5 {
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        'a a b b c c'
        '. d d e e .';
      .tract_grid_item {
        &:nth-child(1) {
          grid-area: a;
        }
        &:nth-child(2) {
          grid-area: b;
        }
        &:nth-child(3) {
          grid-area: c;
        }
        &:nth-child(4) {
          grid-area: d;
        }
        &:nth-child(5) {
          grid-area: e;
        }
      }
    }
    &_6 {
      grid-template-columns: repeat(3, 1fr);
    }
    &_7 {
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        'a a b b c c'
        'd d e e f f'
        '. . g g . .';
      .tract_grid_item {
        &:nth-child(1) {
          grid-area: a;
        }
        &:nth-child(2) {
          grid-area: b;
        }
        &:nth-child(3) {
          grid-area: c;
        }
        &:nth-child(4) {
          grid-area: d;
        }
        &:nth-child(5) {
          grid-area: e;
        }
        &:nth-child(6) {
          grid-area: f;
        }
        &:nth-child(7) {
          grid-area: g;
        }
      }
    }
    &_8 {
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        'a a b b c c'
        'd d e e f f'
        '. g g h h .';
      .tract_grid_item {
        &:nth-child(1) {
          grid-area: a;
        }
        &:nth-child(2) {
          grid-area: b;
        }
        &:nth-child(3) {
          grid-area: c;
        }
        &:nth-child(4) {
          grid-area: d;
        }
        &:nth-child(5) {
          grid-area: e;
        }
        &:nth-child(6) {
          grid-area: f;
        }
        &:nth-child(7) {
          grid-area: g;
        }
        &:nth-child(8) {
          grid-area: h;
        }
      }
    }
    &_9 {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (max-width: 1023px) {
  .tract {
    &_grid {
      &_2-5 {
        grid-template-columns: repeat(4, 1fr);
        grid-template-areas: 'a a b b b';
        .tract_grid_item {
          &:nth-child(1) {
            grid-area: a;
          }
          &:nth-child(2) {
            grid-area: b;
          }
        }
      }
    }
  }
}
</style>
